
import Input from '../../shared/input';
import IconButton from '../../../../icon-button';
import Icon from '../../../../icon';
import Divider from '../../../../divider';
import Gutter from '../../../../gutter';
import Typography from '../../../../typography';
import FileUploaderProps from './mixins/FileUploaderProps';
import { FileUploaderProperty } from './enums';
import { ControlEventType } from '../../enums';
import { TypographyType } from '../../../../typography/enums';
import { IconType } from '../../../../icon/enums';
import FileSizeService from './services/FileSizeService';
import {
  StyleSizeType,
  StyleColorSchemeType,
  StyleOrientationType,
  StylePositionType,
} from '../../../../../styles/enums';
import {
  InputProperty,
  InputType,
  InputEventType,
  InputSlotType,
} from '../../shared/input/enums';

const FILE_INPUT_REF = 'file-input-ref';

export default {
  name: 'FileUploader',
  components: {
    Gutter,
    Typography,
    Divider,
    IconButton,
    Icon,
    Input,
  },
  mixins: [FileUploaderProps],
  data() {
    return {
      file: null,
      FILE_INPUT_REF,
      InputProperty,
      InputType,
      InputEventType,
      IconType,
      InputSlotType,
      TypographyType,
      FileUploaderProperty,
      StyleSizeType,
      StyleColorSchemeType,
      StyleOrientationType,
      StylePositionType,
    };
  },
  computed: {
    inputAccept() {
      return this[FileUploaderProperty.Extensions]
        .map((extension) => `.${extension}`)
        .join(', ');
    },
    prettyFileSize() {
      return FileSizeService.getPrettyFileSize(this.file?.size || 0);
    },
    fileName() {
      return this.file?.name;
    },
  },
  watch: {
    value(value) {
      this.setFileValue(value);
    },
  },
  mounted() {
    this.setFileValue(this[FileUploaderProperty.Value]);
  },
  methods: {
    setFileValue(file) {
      this.file = file;
    },
    openFileUploader() {
      this.$refs[FILE_INPUT_REF]?.click();
    },
    handleRemoveFileButtonClick(event) {
      event.stopPropagation();
      this.file = null;
      this.$refs[FILE_INPUT_REF].value = '';
      this.$emit(ControlEventType.Change, this.file);
    },
    handleFileInputChange(event) {
      [this.file] = event.target.files;
      this.$emit(ControlEventType.Change, this.file);
    },
    handleInputClick() {
      if (this[FileUploaderProperty.Disabled]) {
        return;
      }

      this.openFileUploader();
    },
    handleInputFocus() {
      this.$emit(ControlEventType.Focus);
    },
    handleInputBlur() {
      this.$emit(ControlEventType.Blur);
    },
  },
};
